import { cleanFields } from '../../../utilities/helper/cleanFields';
import request from '../../axios';

const PostFarmAdvertisement = async (payload: IFarmAdvertisementPayload) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    description: payload?.description || undefined,
    il_type: payload?.type,
    ...(payload.price_on_call !== true && {ad_price: payload?.ad_price}),
    price_unit: payload?.price_unit?.value,
    farm: payload?.farm?.guid,
    existing: payload.existing,
    water_system: payload?.water_system?.guid,
    price_on_call: payload?.price_on_call || undefined,
    has_discount: payload?.has_discount || undefined,
    profile_type: 'supplier',
    attributes: payload.attributes,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    irrigation_volume_unit: payload?.irrigation_volume_unit?.guid,
    irrigation_volume_time: payload?.irrigation_volume_time?.guid,
    irrigation_volume: payload?.irrigation_volume,
    is_change_title: payload?.is_change_title,
    images_id: payload?.images?.map(item => item).join(','),
    main_image_id: payload?.main_image?.id,
    only_massage_buyer: payload.only_massage_buyer || false,
    discount_amount: payload?.discount_amount || undefined,
    main_image: payload?.main_image,
    images: payload?.images?.length ? payload?.images : [],
    sub_brand_main_image: null,
    ...(payload?.sub_brand && {sub_brand: payload?.sub_brand}),
    sub_brand_images: payload?.sub_brand_images ?? [],
  };

  const cleanPayload = cleanFields(newPayload, [
    'main_image',
    'sub_brand_main_image',
  ]);

  const response = await request.post(
    `api/v2/store/farm-advertisement`,
    cleanPayload,
  );

  return response.data;
};

export default PostFarmAdvertisement;
